/* eslint-disable import/no-cycle */

'use-strict';

import angular, { ILocationService } from 'angular';
import { RootScope } from '../../app.config';

/* @ngInject */
export class NavService {
  private $location: ILocationService;

  private $rootScope: RootScope;

  constructor(
    $location: ILocationService,
    $rootScope: RootScope,
  ) {
    'ngInject';

    this.$location = $location;
    this.$rootScope = $rootScope;

    this.$rootScope.sidebarOpen = false;
    this.$rootScope.drawerUserSettings = false;
  }

  public toggleUserSettings = (): void => {
    this.$rootScope.drawerUserSettings = !this.$rootScope.drawerUserSettings;
  };

  public navItemIsActive = (path: string): boolean => this.$location.path().includes(path);

  public frontpageIsActive = (): boolean => this.$location.path() === '' || this.$location.path() === '/';

  public toggle = (): void => {
    this.$rootScope.sidebarOpen = !this.$rootScope.sidebarOpen;
  };

  public hide = (): void => {
    this.$rootScope.drawerUserSettings = false;
    this.$rootScope.sidebarOpen = false;
  };
}

export default angular
  .module('services.navService', [])
  .service('navService', NavService)
  .name;
